import { useState } from "react";
import { Field } from "../AdminForm.jsx";

/**
 * Name + email + explicit agreement. `onSubmit({ name, email, agreed: true })`.
 * 4b-4 reuses this for contract signing with different labels.
 */
export function AcceptanceForm({ onSubmit, busy, error, agreeLabel = "I agree to this proposal and its terms.", buttonLabel = "Accept proposal", nameLabel = "Your name", emailLabel = "Your email" }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [agreed, setAgreed] = useState(false);
  const ready = name.trim().length > 0 && /\S+@\S+\.\S+/.test(email) && agreed && !busy;
  return (
    <form className="space-y-3" noValidate onSubmit={(e) => { e.preventDefault(); if (ready) onSubmit({ name: name.trim(), email: email.trim(), agreed: true }); }}>
      <Field label={nameLabel} required value={name} onChange={setName} />
      <Field label={emailLabel} type="email" required value={email} onChange={setEmail} />
      <label className="flex items-start gap-2 text-[13px] text-text-secondary cursor-pointer">
        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-0.5" />
        <span>{agreeLabel}</span>
      </label>
      {error && <p className="text-[12px] text-negative">{error.message}</p>}
      <button type="submit" disabled={!ready} className="w-full px-3 py-2 rounded-card bg-accent text-white text-[13px] font-medium disabled:opacity-50">
        {busy ? "Submitting…" : buttonLabel}
      </button>
    </form>
  );
}
